
import React from "react"
import { LayoutLogoGrid } from "trimble-terra";
import { formatCommonComponentFields } from "./formatLayoutFunctions";
import { formatFocusedImage } from "../formatBaseMolecules";

const FormatAndRenderLayoutLogoGrid = ({ data, locale, siteIdentifier, homepageSlug, currentSpaceId }) => {
  const formattedComponentData = formatCommonComponentFields(data, locale, siteIdentifier, homepageSlug, currentSpaceId);
  
  const formattedLogos = data?.logos?.map((logo) => {
    const focusedImageLogo = logo?.bynderAssetReference?.[0] 
    ? formatFocusedImage({
      image: { file: { url: logo?.bynderAssetReference?.[0]?.src } },
      title: logo.altText || logo.title
    }) 
    : logo?.image
      ? formatFocusedImage(logo) 
      : null;

    return {
      href: logo?.href || null,
      image: focusedImageLogo,
      alt: logo?.altText || logo?.title
    }
  })

  const formattedLogoGrid = {
    ...formattedComponentData,
    logos: formattedLogos
  }

  return (
    <LayoutLogoGrid 
      {...formattedLogoGrid} 
      isWrapped={true}
    />
  )
}

export default FormatAndRenderLayoutLogoGrid